export const movieList = [
  {
    id: 1,
    title: '长夜将尽',
    genre: '悬疑',
    region: '中国大陆',
    year: 2023,
    rating: 8.6,
    duration: '112 分钟',
    tagline: '一桩旧案在雨夜被重新翻开，真相藏在每一次沉默里。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20minimal%20movie%20poster%20art%20with%20rainy%20night%20city%20silhouette%20and%20warm%20amber%20street%20lamp%20glow%2C%20moody%20cinematic%20texture%2C%20deep%20shadow%20contrast%2C%20abstract%20artistic%20illustration%2C%20no%20text%2C%20subtle%20grain%2C%20elegant%20composition&width=600&height=900&seq=cinema-poster-01&orientation=portrait',
  },
  {
    id: 2,
    title: '山海拾光',
    genre: '奇幻',
    region: '中国大陆',
    year: 2022,
    rating: 8.2,
    duration: '128 分钟',
    tagline: '少年循着旧地图走入山海之间，寻找被时间遗忘的光。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20fantasy%20film%20poster%20art%20with%20misty%20mountains%20and%20glowing%20golden%20light%20particles%2C%20ethereal%20atmosphere%2C%20warm%20orange%20and%20cream%20palette%2C%20abstract%20painterly%20illustration%2C%20no%20text%2C%20cinematic%20depth&width=600&height=900&seq=cinema-poster-02&orientation=portrait',
  },
  {
    id: 3,
    title: '归途列车',
    genre: '剧情',
    region: '中国大陆',
    year: 2021,
    rating: 8.8,
    duration: '134 分钟',
    tagline: '一趟跨越三千公里的列车，载着一家人的相聚与告别。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20drama%20film%20poster%20art%20with%20long%20train%20silhouette%20crossing%20golden%20dusk%20field%2C%20nostalgic%20warm%20light%2C%20minimal%20flat%20illustration%2C%20amber%20and%20brown%20tones%2C%20no%20text%2C%20cinematic%20mood&width=600&height=900&seq=cinema-poster-03&orientation=portrait',
  },
  {
    id: 4,
    title: '城市温度',
    genre: '爱情',
    region: '中国香港',
    year: 2023,
    rating: 7.9,
    duration: '106 分钟',
    tagline: '两段错过的相遇，在同一座城市里慢慢靠近。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20romance%20film%20poster%20art%20with%20warm%20city%20skyline%20at%20sunset%20and%20two%20distant%20figures%2C%20soft%20peach%20and%20amber%20gradient%2C%20minimal%20modern%20illustration%2C%20no%20text%2C%20gentle%20cinematic%20glow&width=600&height=900&seq=cinema-poster-04&orientation=portrait',
  },
  {
    id: 5,
    title: '星际回声',
    genre: '科幻',
    region: '中国大陆',
    year: 2024,
    rating: 8.4,
    duration: '140 分钟',
    tagline: '深空里传来的信号，改写了人类对孤独的理解。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20science%20fiction%20film%20poster%20art%20with%20distant%20planet%20and%20warm%20amber%20nebula%20light%2C%20deep%20space%20atmosphere%2C%20abstract%20cosmic%20illustration%2C%20no%20text%2C%20cinematic%20composition%2C%20rich%20orange%20tones&width=600&height=900&seq=cinema-poster-05&orientation=portrait',
  },
  {
    id: 6,
    title: '笑看风云',
    genre: '喜剧',
    region: '中国大陆',
    year: 2022,
    rating: 7.6,
    duration: '98 分钟',
    tagline: '三个落魄小人物，用一场荒诞计划找回体面。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20comedy%20film%20poster%20art%20with%20playful%20geometric%20shapes%20and%20warm%20sunny%20colors%2C%20cheerful%20minimal%20graphic%20illustration%2C%20amber%20and%20coral%20palette%2C%20no%20text%2C%20clean%20composition&width=600&height=900&seq=cinema-poster-06&orientation=portrait',
  },
  {
    id: 7,
    title: '雪落无声',
    genre: '剧情',
    region: '中国大陆',
    year: 2020,
    rating: 9.0,
    duration: '146 分钟',
    tagline: '北方的漫长冬天里，一位老人守着整条街的记忆。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20quiet%20drama%20film%20poster%20art%20with%20snowy%20village%20and%20warm%20window%20light%2C%20muted%20winter%20tones%20with%20amber%20accents%2C%20minimal%20painterly%20illustration%2C%20no%20text%2C%20serene%20cinematic%20mood&width=600&height=900&seq=cinema-poster-07&orientation=portrait',
  },
  {
    id: 8,
    title: '逆风而行',
    genre: '动作',
    region: '中国香港',
    year: 2023,
    rating: 8.1,
    duration: '118 分钟',
    tagline: '一场横跨三座城市的追捕，胜负只在一念之间。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20action%20film%20poster%20art%20with%20dynamic%20diagonal%20motion%20streaks%20and%20warm%20red%20orange%20energy%2C%20bold%20graphic%20illustration%2C%20no%20text%2C%20high%20contrast%20cinematic%20poster%20layout&width=600&height=900&seq=cinema-poster-08&orientation=portrait',
  },
  {
    id: 9,
    title: '海上的信',
    genre: '剧情',
    region: '中国台湾',
    year: 2021,
    rating: 8.3,
    duration: '124 分钟',
    tagline: '一封没有寄出的信，让两代人重新读懂了彼此。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20literary%20film%20poster%20art%20with%20calm%20sea%20horizon%20and%20single%20small%20boat%2C%20soft%20cream%20and%20warm%20beige%20palette%2C%20minimal%20watercolor%20illustration%2C%20no%20text%2C%20quiet%20cinematic%20mood&width=600&height=900&seq=cinema-poster-09&orientation=portrait',
  },
  {
    id: 10,
    title: '时间旅人',
    genre: '科幻',
    region: '中国大陆',
    year: 2024,
    rating: 8.7,
    duration: '132 分钟',
    tagline: '他用一生研究时间，却只想回到那个下午。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20time%20travel%20film%20poster%20art%20with%20melting%20clock%20shapes%20and%20warm%20amber%20light%20rays%2C%20surreal%20abstract%20illustration%2C%20no%20text%2C%20elegant%20cinematic%20composition%2C%20golden%20tones&width=600&height=900&seq=cinema-poster-10&orientation=portrait',
  },
  {
    id: 11,
    title: '老巷茶馆',
    genre: '喜剧',
    region: '中国大陆',
    year: 2022,
    rating: 8.5,
    duration: '110 分钟',
    tagline: '一间老茶馆里，藏着半座城市的喜怒哀乐。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20warm%20slice%20of%20life%20film%20poster%20art%20with%20old%20tea%20house%20interior%20and%20hanging%20lanterns%2C%20cozy%20amber%20light%2C%20minimal%20retro%20illustration%2C%20no%20text%2C%20nostalgic%20cinematic%20mood&width=600&height=900&seq=cinema-poster-11&orientation=portrait',
  },
  {
    id: 12,
    title: '都市迷踪',
    genre: '悬疑',
    region: '中国香港',
    year: 2023,
    rating: 8.0,
    duration: '120 分钟',
    tagline: '一条匿名线索，把记者卷进城市的隐秘角落。',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20mystery%20film%20poster%20art%20with%20dark%20city%20alley%20and%20single%20warm%20neon%20reflection%2C%20moody%20deep%20shadow%2C%20minimal%20graphic%20illustration%2C%20no%20text%2C%20tense%20cinematic%20atmosphere&width=600&height=900&seq=cinema-poster-12&orientation=portrait',
  },
];

export const genreList = ['全部', '剧情', '悬疑', '科幻', '喜剧', '爱情', '动作', '奇幻'];

export const featureList = [
  {
    icon: 'ri-movie-2-line',
    title: '在线观看入口整合',
    desc: '把分散的观影入口与浏览方向整理在同一处，减少来回跳转，打开即可按主题分类继续查找。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清播放体验',
    desc: '面向高清播放场景说明画质、清晰度与播放设置，帮你在网络条件允许时获得更稳定的画面。',
  },
  {
    icon: 'ri-gift-line',
    title: '免费观影信息',
    desc: '围绕免费观影整理常见疑问与查看方式，把能免费看什么、怎么看说明白，少走弯路。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '手机版直达',
    desc: '手机浏览器打开即可浏览，页面按小屏优化排版，无需额外下载应用也能顺畅看完内容。',
  },
];

export const rankingList = [
  {
    rank: 1,
    title: '雪落无声',
    genre: '剧情',
    rating: 9.0,
    reason: '节奏沉稳、情绪克制，适合安静下来完整地看完一遍，是站内长期被反复提起的一部。',
  },
  {
    rank: 2,
    title: '归途列车',
    genre: '剧情',
    rating: 8.8,
    reason: '把家庭关系放进一段旅程里讲清楚，画面与配乐都被观众反复讨论。',
  },
  {
    rank: 3,
    title: '时间旅人',
    genre: '科幻',
    rating: 8.7,
    reason: '用科幻外壳包裹细腻情感，设定不复杂但后劲很足，适合喜欢慢慢品的人。',
  },
  {
    rank: 4,
    title: '长夜将尽',
    genre: '悬疑',
    rating: 8.6,
    reason: '线索铺陈扎实、反转不刻意，喜欢推理与氛围感的观众口碑稳定。',
  },
  {
    rank: 5,
    title: '老巷茶馆',
    genre: '喜剧',
    rating: 8.5,
    reason: '轻喜剧的底色下有市井温度，短小精悍，适合零碎时间当作放松之选。',
  },
];

export const faqList = [
  {
    q: '九七电影院提供的是什么内容？',
    a: '本站围绕在线观影入口做信息整理，把在线观看、免费观影、高清播放、手机版等相关内容集中呈现，方便你按自己的需求找到对应说明，而不是在多个页面之间反复搜索。',
  },
  {
    q: '在手机上能正常浏览吗？',
    a: '可以。页面按小屏做了排版适配，导航、卡片与列表在手机上会改为纵向排列，文字与按钮尺寸也做了放大处理，使用手机浏览器打开即可顺畅阅读与操作。',
  },
  {
    q: '高清播放需要额外设置吗？',
    a: '通常不需要。画质表现更多取决于你的网络环境与设备屏幕，网络稳定时画面会更清晰；如遇卡顿，可先暂停缓冲片刻，或切换到更稳定的网络环境再继续观看。',
  },
  {
    q: '免费观影相关的内容怎么看？',
    a: '免费观影的部分以信息说明为主，我们会用一般性的描述解释可查看的方向与常见疑问。由于不同时段、不同区域的情况可能变化，具体请以你实际打开时看到的页面为准。',
  },
  {
    q: '网页入口和网址应该怎么记？',
    a: '建议把常用的网页入口加入浏览器书签，之后直接从书签打开即可，不必每次重新搜索。若某个入口暂时无法访问，可稍后重试或换用其他网络环境再试。',
  },
  {
    q: '站内的片单和评分是真实的吗？',
    a: '页面中的片单、评分与介绍为示例内容，用于演示信息组织方式，并不代表某个平台的实时数据，也不构成对任何具体作品的评价。请以你实际查看时页面呈现的内容为准。',
  },
];

export const stepGuide = [
  {
    n: '01',
    title: '打开网页入口',
    desc: '在手机或电脑浏览器中输入或选择九七电影院网页入口，进入本站首页即可看到整体说明。',
  },
  {
    n: '02',
    title: '按分区浏览',
    desc: '通过顶部导航或页面分区快速定位：想看片单看「精选片单」，想了解设备看「多端适配」。',
  },
  {
    n: '03',
    title: '筛选与搜索',
    desc: '在片单区域用类型标签筛选，或在搜索框输入片名关键词，列表会即时更新为符合条件的结果。',
  },
  {
    n: '04',
    title: '选择合适画质',
    desc: '在网络稳定时优先选择高清播放，画面细节更清楚；网络较弱时先保证流畅，再逐步提升画质。',
  },
  {
    n: '05',
    title: '收藏常用入口',
    desc: '把本页加入书签，下次直接从书签打开，省去反复搜索网址的时间。',
  },
];

export const deviceList = [
  {
    icon: 'ri-smartphone-line',
    name: '手机版',
    desc: '竖屏优先排版，导航自动收起为菜单，列表与卡片改为单列，拇指操作区域更大。',
    tag: '手机浏览器直接访问',
  },
  {
    icon: 'ri-tablet-line',
    name: '平板设备',
    desc: '横屏时片单自动切换为多列网格，竖屏时回到双列，图文比例更接近阅读习惯。',
    tag: '横竖屏自适应',
  },
  {
    icon: 'ri-computer-line',
    name: '电脑网页',
    desc: '大屏下信息密度更高，可在同一屏内同时看到导航、片单与说明，适合一次性浏览大量内容。',
    tag: '信息密度更完整',
  },
  {
    icon: 'ri-tv-2-line',
    name: '电视投屏',
    desc: '在支持投屏的设备上，可将浏览画面投到大屏幕，配合客厅环境获得更沉浸的观看氛围。',
    tag: '大屏观看氛围',
  },
];

export const entranceNotes = [
  {
    icon: 'ri-bookmark-3-line',
    title: '优先使用书签',
    desc: '把当前页面加入浏览器书签，之后从书签进入即可，避免在搜索过程中点到名称相近的其他站点。',
  },
  {
    icon: 'ri-router-line',
    title: '网络环境建议',
    desc: '观看高清内容时建议连接稳定的网络。若页面加载偏慢，可先切换网络或稍后重试，再继续浏览。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '注意信息辨别',
    desc: '遇到要求输入账号密码、支付信息或下载未知程序的页面时请提高警惕，本站不涉及此类操作。',
  },
  {
    icon: 'ri-refresh-line',
    title: '入口临时不可用',
    desc: '若某个入口短时间无法打开，通常是网络波动所致，可稍等片刻后重新访问，或换用另一台设备尝试。',
  },
];